import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterReference',
})
export class FilterReferencePipe implements PipeTransform {
  transform(items: any[], searchTerm: string, labelKey?: string): any {
    if (!items || !searchTerm) {
      return items;
    }

    return items.filter((item) => {
      if (item.hasOwnProperty('StateName')) {
        return (
          item[labelKey || 'StateName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true ||
          item[labelKey || 'StateCode']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('CountryName')) {
        return (
          item[labelKey || 'CountryName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('BankName')) {
        return (
          item[labelKey || 'BankName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('LgaName')) {
        return (
          item[labelKey ||'LgaName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('CommunityName')) {
        return (
          item[labelKey || 'CommunityName']
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('RequestTypeName')) {
        return (
          item[labelKey || 'RequestTypeName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('TitleName')) {
        return (
          item[labelKey || 'TitleName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('AssetStatusName')) {
        return (
          item[labelKey || 'AssetStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('CorrespondenceCompanyName')) {
        return (
          item[labelKey || 'CorrespondenceCompanyName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('CorrespondenceTeamName')) {
        return (
          item[labelKey || 'CorrespondenceTeamName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('SexName')) {
        return (
          item[labelKey || 'SexName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('LandPrefixName')) {
        return (
          item[labelKey || 'LandPrefixName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('PaymentStatusName')) {
        return (
          item[labelKey || 'PaymentStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('IncidentAddNumber')) {
        return (
          item[labelKey || 'IncidentAddNumber']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('LossOfUseItemDesc')) {
        return (
          item[labelKey || 'LossOfUseItemDesc']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('YearOfSuitName')) {
        return (
          item[labelKey || 'YearOfSuitName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('LicenceStatusName')) {
        return (
          item[labelKey || 'LicenceStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('LessorRepTypeName')) {
        return (
          item[labelKey || 'LessorRepTypeName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('DamageStatusName')) {
        return (
          item[labelKey || 'DamageStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('PoleName')) {
        return (
          item[labelKey || 'PoleName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('value')) {
        return (
          item[labelKey || 'value'].toLowerCase().includes(searchTerm.toLowerCase()) === true ||
          item[labelKey || 'ModuleActivity_ActivityId'].toLowerCase().includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('CounselTypeName')) {
        return (
          item[labelKey || 'CounselTypeName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('IncidentCategoryName')) {
        return (
          item[labelKey || 'IncidentCategoryName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('DatumName')) {
        return (
          item[labelKey || 'DatumName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('DocumentCategoryName')) {
        return (
          item[labelKey || 'DocumentCategoryName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true ||
          item[labelKey || 'DocumentCategoryCode']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('value')) {
        return (
          item[labelKey || 'value']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('CofOStatusName')) {
        return (
          item[labelKey || 'CofOStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true ||
          item[labelKey || 'COfODate']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('QuantumName')) {
        return (
          item[labelKey || 'QuantumName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('SubSubGroupTypeCategoryName')) {
        return (
          item[labelKey || 'SubSubGroupTypeCategoryName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('IncidentQuantumName')) {
        return (
          item[labelKey || 'IncidentQuantumName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('IncidentSubCategoryName')) {
        return (
          item[labelKey || 'IncidentSubCategoryName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true ||
          item[labelKey || 'IncidentCategoryId']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('RateStatus')) {
        return (
          item[labelKey || 'RateStatus']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('ObligationPeriodName')) {
        return (
          item[labelKey || 'ObligationPeriodName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true ||
          item[labelKey || 'ObligationPeriodDays']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('DocumentTypeCodeName')) {
        return (
          item[labelKey || 'DocumentTypeCodeName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true ||
          item[labelKey || 'DocumentTypeCodeMainName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('EncroachmentStatusName')) {
        return (
          item[labelKey || 'EncroachmentStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('EncroachmentTypeName')) {
        return (
          item[labelKey || 'EncroachmentTypeName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('ExpirationStatusName')) {
        return (
          item[labelKey || 'ExpirationStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('FacilityAssetName')) {
        return (
          item[labelKey || 'FacilityAssetName'].toLowerCase().includes(searchTerm.toLowerCase()) === true ||
          item[labelKey || 'FacilityCode'].toLowerCase().includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('FileLocationName')) {
        return (
          item[labelKey || 'FileLocationName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      
      // } else if (item.hasOwnProperty('CompanyName')) {
      //   return (
      //     item[labelKey || 'CompanyName']
      //       .toLowerCase()
      //       .includes(searchTerm.toLowerCase()) === true
      //   );
      } else if (item.hasOwnProperty('IPStatusName')) {
        return (
          item[labelKey || 'IPStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('IssuedCategoryName')) {
        return (
          item[labelKey || 'IssuedCategoryName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('ItemTypeName')) {
        return (
          item[labelKey || 'ItemTypeName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('LandUseStatusName')) {
        return (
          item[labelKey || 'LandUseStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('LorpName')) {
        return (
          item[labelKey || 'LorpName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('MeasureName')) {
        return (
          item[labelKey || 'MeasureName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('NetworkName')) {
        return (
          item[labelKey || 'NetworkName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('AccountableFunctionName')) {
        return (
          item[labelKey || 'AccountableFunctionName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('FunctionName')) {
        return (
          item[labelKey || 'FunctionName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('type')) {
        return (
          item[labelKey || 'leftvalue']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true ||
          item[labelKey || 'rightvalue']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('AcquisitionTypeName')) {
        return (
          item[labelKey || 'AcquisitionTypeName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('ActivityStatusName')) {
        return (
          item[labelKey || 'ActivityStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('AddressTypeName')) {
        return (
          item[labelKey || 'AddressTypeName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('BankingStatusName')) {
        return (
          item[labelKey || 'BankingStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('BatchName')) {
        return (
          item[labelKey || 'BatchName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('CabinetShelfRefNo')) {
        return (
          item[labelKey || 'CabinetShelfRefNo']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('CategoryName')) {
        return (
          item[labelKey || 'CategoryName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('ClaimTypeName')) {
        return (
          item[labelKey || 'ClaimTypeName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('CleanUpStatusName')) {
        return (
          item[labelKey || 'CleanUpStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('CompanyName')) {
        return (
          item[labelKey || 'CompanyName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('ContinentName')) {
        return (
          item[labelKey || 'ContinentName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('CurrencyName')) {
        return (
          item[labelKey || 'CurrencyName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('ItemName')) {
        return (
          item[labelKey || 'ItemName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('DeliveryTypeName')) {
        return (
          item[labelKey || 'DeliveryTypeName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('DivestmentStatusName')) {
        return (
          item[labelKey || 'DivestmentStatusName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('DivisionName')) {
        return (
          item[labelKey || 'DivisionName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('DocumentTypeName')) {
        return (
          item[labelKey || 'DocumentTypeName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('SubSubGroupName')) {
        return (
          item[labelKey || 'SubSubGroupName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('SubGroupName')) {
        return (
          item[labelKey || 'SubGroupName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('RackTrayRefNo')) {
        return (
          item[labelKey || 'RackTrayRefNo']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('RequestCategoryName')) {
        return (
          item[labelKey || 'RequestCategoryName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('RequestSubCategoryName')) {
        return (
          item[labelKey || 'RequestSubCategoryName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('GroupName')) {
        return (
          item[labelKey || 'GroupName']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      } else if (item.hasOwnProperty('LandTitleId')) {
        return (
          item[labelKey || 'LandTitleId']
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) === true
        );
      }
    });
  }
}
